"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowRequiredFields = void 0;
const react_1 = require("react");
const workflow_core_1 = require("@sierralabs/workflow-core");
const RequiredFieldsPlugin_1 = require("../plugins/transition-conditions/RequiredFieldsPlugin");
function getRequiredFields(stateNode, eventName) {
    var _a;
    const event = (_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.events) === null || _a === void 0 ? void 0 : _a.find(e => e.name === eventName);
    const requiredFields = [];
    for (const transition of (event === null || event === void 0 ? void 0 : event.transitions) || []) {
        for (const condition of transition.conditions || []) {
            const params = condition.params;
            if (condition.type === RequiredFieldsPlugin_1.RequiredFieldsPlugin.type &&
                params &&
                Array.isArray(params.requiredFields)) {
                requiredFields.push(...params.requiredFields);
            }
        }
    }
    return requiredFields;
}
function createValidator(stateNode, eventName) {
    const requiredFields = getRequiredFields(stateNode, eventName);
    const validateField = (field, value) => {
        // field is valid if not in requiredFields or if it passed validate check
        return !requiredFields.includes(field) || (0, workflow_core_1.validateRequiredField)(value);
    };
    const validateObject = (object) => {
        return requiredFields.every(field => validateField(field, object[field]));
    };
    return { requiredFields, field: validateField, object: validateObject };
}
function useWorkflowRequiredFields(stateNode) {
    const [eventName, setEventName] = (0, react_1.useState)();
    const getValidator = (0, react_1.useCallback)((eventName) => createValidator(stateNode, eventName), [stateNode]);
    const validate = (0, react_1.useMemo)(() => {
        return getValidator(eventName);
    }, [eventName, getValidator]);
    return { eventName, validate, getValidator, setEventName };
}
exports.useWorkflowRequiredFields = useWorkflowRequiredFields;
//# sourceMappingURL=useWorkflowRequiredFields.js.map